import { render, staticRenderFns } from "./InformeAuditoriaActionButtonsAprobador.vue?vue&type=template&id=ca5a9ce0&"
import script from "./InformeAuditoriaActionButtonsAprobador.vue?vue&type=script&lang=js&"
export * from "./InformeAuditoriaActionButtonsAprobador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {
  VBtn,
})
